import ButtonLink from '../../../common/components/Button/ButtonLink.js'
import Weight from '../../../common/components/Weight.js'
import {weightSelector} from '../../../data/products.js'
import {lbToOz} from '../../../common/weight.js'
import {showProductWeightModal} from '../Modals/ProductWeightModal.js'
import {useSelector} from '../../../store.js'

export default function WeightCell({sku}) {
  const weight = useSelector((state) => weightSelector(state, {sku}))

  return (
    <td className="table__td table__td--product-list-weight">
      <span className="margin-right-5">
        <ButtonLink
          className="darkest"
          onClick={() => showProductWeightModal([sku], weight)}
        >
          <Weight value={lbToOz(weight)} />
        </ButtonLink>
      </span>
    </td>
  )
}
